export const CustomerRegistrationTypes = [
  {
    key: 'NRIC',
    label: 'NRIC',
  },
  {
    key: 'BRN',
    label: 'BRN',
  },
  {
    key: 'PASSPORT',
    label: 'PASSPORT',
  },
  {
    key: 'ARMY',
    label: 'ARMY',
  },
]
